import React from 'react';
import { v4 as uuidv4 } from "uuid"
import Cookies from "universal-cookie"
import SearchList from './SearchList';
import { Link } from "@StarberryUtils"
import FloorPlanModal from "../SearchResult/floorPlanModal"
import VideoPlay from "../Play/property-results-video"
import parse from "html-react-parser"
import MailingForm from "../forms/join-mailing-list"
import ModalTiny from "react-bootstrap/Modal"
const mycookies = new Cookies()
const InfiniteHits = ({
  hits,
  // hasPrevious,
  // refinePrevious,
  // hasMore,
  // refineNext,
  // location,
  tag,
  source,
  department,
  noResult,
  closeSharefrndformModal,
  openSharefrndformModal,
  modalSharefrndformOpen
  // userObjects,
}) => (
  <>
    {hits?.length > 0 && hits.map((hitItem, i) => {
      // property details url structure

      let valuationText = ""
      if(((i + 1) % 8) === 0) {
         valuationText = "even"
      }else  if(((i + 1) % 4) === 0) {
         valuationText = "add"
      }

      let uriStr = ""
      let mysale = ""
      let hit = { ...hitItem }
      // mapping
      hit.searchType = hit.searchType || hit.search_type;

      if (hit.searchType === "sales" && hit.department === "residential") {
        uriStr = `property-for-sale-details/`
        mysale = `myResSaleProp`
      } else if (
        hit.searchType === "lettings" &&
        hit.department === "residential"
      ) {
        uriStr = `property-to-rent-details/`
        mysale = `myResRentProp`
      }

      if (tag === "sold") {
        uriStr = `property-sold/`
        mysale = `myResSaleProp`
      } else if (tag === "let") {
        uriStr = `property-let/`
        mysale = `myResRentProp`
      }

      let url_one = ""
      let photoplans = false

      if (hit.virtual_tour) {
        url_one = String(hit.virtual_tour)
        if(url_one.indexOf("photoplans.planup") > -1 || url_one.indexOf("videos.spaces") > -1)
        photoplans = true
      }
      // property details url structure
      if (department === 'newhomes') {
        hit.price_qualifier = 'Price from';
        uriStr = 'new-homes/current-developments-details/';
        hit.bedroom = hit.title;

        //remove html tags from a string, leaving only the inner text
        function removeHTML(str) {
          var tmp = document.createElement("DIV");
          tmp.innerHTML = str;
          return tmp.textContent || tmp.innerText || "";
        }

        hit.description = hit?.description ? removeHTML(hit.description) : ''
      }
      if (department === 'international') {
        hit.price_qualifier = 'Price from';
        uriStr = 'international-property-for-sale-details/';
        hit.bedroom = hit.title;

        //remove html tags from a string, leaving only the inner text
        function removeHTML(str) {
          var tmp = document.createElement("DIV");
          tmp.innerHTML = str;
          return tmp.textContent || tmp.innerText || "";
        }

        hit.description = hit?.description ? removeHTML(hit.description) : ''
      }
      return (
        <>
          <div
            className={`property-card ${noResult ? '' : 'mysingleproperty'}`}
            id={`${hit.objectID}`}
            data-objectid={hit.objectID}
            data-lat={hit?._geoloc?.lat}
            data-lng={hit?._geoloc?.lng}
          >
            {tag == "sold" || tag == "let" ? (
              <div className="result-tile">
                <div className="map-wrapper">
                  <SearchList
                    {...hit}
                    // images={hit.images}
                    // floorplan={hit.floorplan}
                    // virtual_tour={hit.virtual_tour}
                    Title={hit.display_address}
                    Address={hit.title}
                    listName={department}
                    // status={hit.status}
                    link=""
                    priceQualifier={hit.price_qualifier && hit.price_qualifier}
                    priceDetails={hit.price && hit.price.toLocaleString()}
                    buildingType={hit.building}
                    // bedroom={hit.bedroom}
                    // bathroom={hit.bathroom}
                    // reception={hit.reception}
                    // description={hit.description}
                    unkey={uuidv4()}
                    photoplans={photoplans}
                    source={source}
                  //   videoid={item.video}
                  />
                  {hit.floorplan && JSON.stringify(hit.floorplan) !== "[]" ? (
                    <FloorPlanModal floorplanimg={hit.floorplan.url} />
                  ) : (
                    ""
                  )}
                  <>
                    {hit.status === "Sold STC" ? (
                      <div className="flag">SOLD STC</div>
                    ) : (
                      ""
                    )}
                    {hit.status === "Let Agreed" ? (
                      <div className="flag">LET AGREED</div>
                    ) : (
                      ""
                    )}
                    {photoplans == true ? (
                      <a
                        href={hit.virtual_tour}
                        target="_blank"
                        className="photoplan"
                      >
                        <span className="play-btn">
                          <i className="icon-play"></i>
                        </span>
                      </a>
                    ) : (
                      <>
                        {hit.virtual_tour ? (
                          hit.virtual_tour.length > 0 ? (
                            <VideoPlay url={hit.virtual_tour} />
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </>
                </div>
              </div>
            ) : (
              <div className="result-tile">
                <Link
                  onClick={() =>
                    mycookies.set(mysale, hit.objectID, {
                      path: "/",
                      maxAge: 300,
                    })
                  }
                  // to={`/${uriStr}${hit.slug}-${hit.objectID}`}
                  propID={hit.objectID}
                  className="map-wrapper"
                >
                  <SearchList
                    {...hit}
                    // images={hit.images}
                    // floorplan={hit.floorplan}
                    // virtual_tour={hit.virtual_tour}
                    Title={hit.display_address}
                    Address={hit.title}
                    // status={hit.status}
                    listName={department}
                    link={`/${uriStr}${hit.slug}-${hit.objectID || hit.id}`}
                    priceQualifier={hit.price_qualifier && hit.price_qualifier}
                    priceDetails={hit.price && hit.price.toLocaleString()}
                    buildingType={hit.building}
                    // bedroom={hit.bedroom}
                    // bathroom={hit.bathroom}
                    // reception={hit.reception}
                    // description={hit.description}
                    unkey={uuidv4()}
                    photoplans={photoplans}
                    source={source}
                  //   videoid={item.video}
                  />
                </Link>
              </div>
            )}
          </div>
          {valuationText === "add" &&
              <div className="static-register-withus-module">
                <div className="left-side">
                    <h2><em>Stay</em> in the loop.</h2>
                    <p>Sign up to our newsletter to stay up to date with what's happening in your neighbourhood</p>
                </div>
                <div className="right-side">
                <a href="javascript:void(0)" onClick={()=> { openSharefrndformModal();}} className="btn btn_cray btn-mailing-list">Join Mailing List</a>
                  </div>
              </div>
          }

          {valuationText === "even" &&
              <div className="static-register-withus-module">
                <div className="left-side">
                    <h2><em>Stay</em> in the loop.</h2>
                    <p>Stay up to date with the value of your home by receiving a free online valuation, or book an in-person valuation here</p>
                </div>
                <div className="right-side">
                <a href="/property-valuation/" className="btn btn_cray btn-mailing-list" target='_blank'>Book a valuation</a>
                  </div>
              </div>
          }
      
        </>
      )
    })}
    <ModalTiny show={modalSharefrndformOpen} onHide={closeSharefrndformModal} className="book-a-viewing-modal getin-touch">
        <ModalTiny.Header closeButton className="contact-close-btn">
            <ModalTiny.Title className="w-100"><h2 className="text-center mb-0 text-uppercase">In your neighbourhood</h2></ModalTiny.Title>            
        </ModalTiny.Header>
        <ModalTiny.Body className="event-section">
            <p>Sign up to our newsletter to find out about the latest property market trends, events and happenings in your area.</p>
            <MailingForm to_email_id={`marketing@redbrik.co.uk`}/>
        </ModalTiny.Body>
    </ModalTiny>
  </>
)

export default InfiniteHits;
